export default __webpack_public_path__ + "static/hub@2x-770ee8e36461f0f1058731cf28c5b36a.png";